/**
 * PostHog Event Registry
 *
 * All tracked PostHog event names must be defined here as constants.
 * Never use raw event name strings in posthog.capture() calls — always
 * reference POSTHOG_EVENTS to keep instrumentation auditable and grep-able.
 */

export const POSTHOG_EVENTS = {
  // ── Contract Scanning ──────────────────────────────────────────────
  contract_scan_started: 'contract_scan_started',
  contract_scan_succeeded: 'contract_scan_succeeded',
  contract_scan_failed: 'contract_scan_failed',

  // ── Milestone Launch ───────────────────────────────────────────────
  milestone_launch_started: 'milestone_launch_started',
  milestone_launch_succeeded: 'milestone_launch_succeeded',
  milestone_launch_failed: 'milestone_launch_failed',

  // ── Email Dispatch ─────────────────────────────────────────────────
  email_dispatch_succeeded: 'email_dispatch_succeeded',
  email_dispatch_failed: 'email_dispatch_failed',

  // ── Checkout / Token Purchase ──────────────────────────────────────
  checkout_started: 'checkout_started',
  checkout_succeeded: 'checkout_succeeded',
  checkout_failed: 'checkout_failed',

  // ── Web Vitals (RUM) ──────────────────────────────────────────────
  web_vital_reported: 'web_vital_reported',
} as const;

export type PostHogEventName = (typeof POSTHOG_EVENTS)[keyof typeof POSTHOG_EVENTS];
